export default __webpack_public_path__ + "static/media/videoAlert.ac2d6be9.mp3";